<template>
  <footer
    class="bottom-0 z-10 flex max-h-[102px] min-h-[102px] w-full justify-between border-t bg-white p-4 lg:max-h-[120px] lg:min-h-[120px]"
    :class="[fixed ? 'fixed' : 'sticky']"
  >
    <div class="flex w-full justify-center items-center">
      <slot></slot>
    </div>
  </footer>
</template>

<script>
export default {
  props: {
    sticky: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
